<template>
  <!-- Banner Section -->
  <v-card class="mx-auto mt-n3">
    <v-img :src="`${url}${data.banners[0].web}`" class="my-3" contain />
    <v-card-title class="justify-center text-uppercase page-title">
      {{ data.title }}
    </v-card-title>
    <!-- Banner Section -->

    <!-- Tabs Section -->
    <v-tabs
      background-color=" accent-4"
      centered
      class="mytabs"
      v-model="selectedTab"
    >
      <template v-for="(tab, i) in tabs">
        <v-tab
          :href="`#${tab.value}`"
          :class="
            i === 0
              ? 'border-radiusbefore'
              : i === tabs.length - 1
              ? 'border-radiusafter'
              : ''
          "
          @click="onSelectTab(tab.value)"
        >
          {{ tab.text }}
        </v-tab>
        <v-tab-item :value="tab.value">
          <v-container>
            <v-app-bar
              width="45%"
              class="mx-auto rounded-xl mb-10"
              color="#E8EFFE"
              flat
            >
              <v-avatar class="ma-3" size="24" tile>
                <v-img :src="require('../../assets/images/global.svg')"></v-img>
              </v-avatar>
              <v-spacer></v-spacer>
              <v-toolbar-title class="text-center"
                >See a list of all our flight destinations</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn
                class="mx-1 rounded-pill gradiant-blue"
                dark
                @click="onExploreClick"
              >
                Explore
              </v-btn>
            </v-app-bar>
            <v-data-table
              :headers="headers"
              :items="airlines"
              class="mytable"
              :loading="loader"
            >
              <template v-slot:[`item.callsign`]="{ item }">
                <div class="text-uppercase">{{ item.callsign }}</div></template
              >
              <template v-slot:[`item.contact`]="{ item }">
                <a style="color: #374151" :href="`tel:item.contact`">{{
                  item.contact
                }}</a>
              </template>
              <template v-slot:[`item.logo`]="{ item }">
                <v-card flat color="transparent" class="pt-6 pb-6">
                  <v-card-title class="pa-0 ml-6">
                    <v-avatar tile size="64">
                      <img :src="item.logo" class="" />
                    </v-avatar>
                    <p class="mb-0 ml-6">
                      {{ item.name }}
                    </p>
                  </v-card-title>
                </v-card>
              </template>
              <template v-slot:[`item.webcheckin`]="{ item }">
                <a
                  :href="item.webcheckin"
                  target="_blank"
                  class="mx-2 rounded-pill px-6 py-2 checkinBtn"
                  depressed
                >
                  <v-icon style="color: #374151">
                    mdi-checkbox-marked-outline {{ item.webcheckin }}
                  </v-icon>
                  Check in
                </a>
              </template>
              <template v-slot:[`item.moreInfo`]="{ item }">
                <v-btn
                  class="mx-2 rounded-pill gradiant-blue pl-6 pr-6"
                  dark
                  @click="onRowClick(item)"
                >
                  More Info {{ item.moreInfo }}
                </v-btn>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
      </template>
    </v-tabs>
    <!-- Tabs Section -->

    <!-- Map Section -->
    <v-row
      align="center"
      justify="center"
      :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
    >
      <v-col cols="12">
        <v-card flat class="mx-auto text-center">
          <v-card-subtitle class="pl-5 text-uppercase page-title">
            our routes
          </v-card-subtitle>
          <v-card-subtitle class="page-sub-title">
            <h2>Flying to {{ destinations.length }}+ destinations</h2>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-container ref="targetRef">
      <div class="rounded-xl" id="map"></div>
    </v-container>
    <!-- Map Section -->
  </v-card>
</template>
<script>
import mapboxgl from "mapbox-gl";
import config from "../../config";
import api from "../../api";

export default {
  name: "Template-3",
  props: ["data"],
  data() {
    return {
      url: config.airport.url,
      tabs: [
        { text: "Domestic", value: "domestic" },
        { text: "International", value: "international" },
      ],
      selectedTab: "domestic",
      allAirlines: [],
      airlines: [],
      language: this.$store.getters.language,
      loader: false,
      destinations: [],
      headers: [
        {
          class: "header-airline",
          text: "Airline",
          filterable: false,
          value: "logo",
          sortBy: "flight",
          sortable: false,
        },
        { text: "Airline Contact No.", value: "contact", sortable: false },
        { text: "Web Check-in", value: "webcheckin", sortable: false },
        { text: "", value: "moreInfo", sortable: false },
      ],
      pagination: {
        page: 1,
        limit: 50,
      },
    };
  },
  watch: {
    "$store.getters.language": async function () {
      await onLoadAirlines();
      await onLoadDestinations();
    },
  },
  methods: {
    onSelectTab(value) {
      this.loader = true;
      this.airlines = this.allAirlines.filter((item) =>
        item.types.includes(value.toUpperCase())
      );
      this.loader = false;
    },
    async onLoadAirlines() {
      this.loader = true;
      let allAirlines = [];
      const { data } = await api.airport.post("/user/airline", {
        ...this.pagination,
        filters: {
          language: this.language,
        },
      });
      allAirlines = data.data.docs;
      allAirlines = allAirlines.map((item) => {
        let contact = item?.contacts?.length ? item.contacts[0] : null;
        let webcheckin = item.links.find((item) => item.type == "WEB_CHECKIN");
        return {
          ...item,
          logo: item.images.logo ? `${this.url}${item.images.logo}` : "",
          contact: contact ? `${contact.phone.code} ${contact.phone.no}` : "",
          webcheckin: webcheckin ? webcheckin.url : "",
        };
      });

      this.allAirlines = allAirlines;
      this.airlines = this.allAirlines.filter((item) =>
        item.types.includes(this.selectedTab.toUpperCase())
      );
      this.loader = false;
    },
    onRowClick(row) {
      try {
        this.$store.dispatch("onUpdateAirline", {
          _id: row.id,
          icao: row.icao,
        });
        this.$router.push(`/airline/${row._id}`);
      } catch (error) {
        console.log(error);
      }
    },
    onExploreClick() {
      this.$refs.targetRef.scrollIntoView({
        behavior: "smooth",
        inline: "start",
      });
    },
    onConfigureMap() {
      mapboxgl.accessToken = config.map.token;
      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/merrillgonsalves/clkgzrx7h008c01qy6kvzevhl",
        zoom: 2,
        attributionControl: false,
        projection: {
          name: "equirectangular",
          center: [80.16684476066258, 12.983596468763904],
        },
        center: [80.16684476066258, 12.983596468763904],
        zoom: 3,
      });
    },
    onConfigureMarkers(coordinates = [], title = "") {
      if (coordinates.length) {
        const popup = new mapboxgl.Popup({ offset: 25 }).setText(` ${title}`);
        this.marker1 = new mapboxgl.Marker({ color: "#0072FF" })
          .setLngLat(coordinates)
          .setPopup(popup)
          .addTo(this.map);
      }
    },
    onHandleMarkerDialog() {
      this.popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      });
    },
    async onLoadDestinations() {
      const { data } = await api.airport.post("/user/airline/destinations", {
        language: this.language,
      });

      if (data.success) {
        this.destinations = data.data;
        for (const destination of this.destinations) {
          this.onConfigureMarkers(
            [
              destination.coordinates.longitude,
              destination.coordinates.latitude,
            ],
            destination.name
          );
        }
      }
    },
  },
  async mounted() {
    this.onConfigureMap();
    await this.onLoadAirlines();
    await this.onLoadDestinations();
    this.onConfigureMarkers();
    this.onHandleMarkerDialog();
  },
};
</script>
<style type="text/css">
.mapboxgl-ctrl-logo {
  display: none !important;
}
.mytable .v-card__title p {
  font-size: 18px !important;
  font-weight: 700;
}

#map {
  height: 600px;
}

.v-alert {
  margin-bottom: 0;
  padding: 6px 18px;
}

.v-list-item {
  padding: 0;
}

.v-btn.filterBtn {
  min-width: 65px !important;
}

.small-text-table {
  font-size: 16px;
  font-weight: 500;
}

.v-list-item__avatar {
  align-self: flex-start !important;
  margin-top: 12px !important;
}

.v-list-item__content {
  padding: 1px 0 1px 0 !important;
}

.searchBox {
  max-width: 1050px;
  margin: 0 auto;
}

.searchBox .v-list-item {
  padding: 0 !important;
}

.fillterIconSmall .v-image__image--cover {
  background-size: inherit;
  flex: none !important;
}

.mytabs .v-item-group {
  margin-bottom: 30px;
}

.v-btn__content {
  flex: none !important;
}
.mytable .v-data-table__wrapper table tbody tr {
  border: 2px solid #e5e7eb !important;
}

.checkinBtn {
  background-color: rgb(232, 239, 254);
  border-color: rgb(232, 239, 254);
  color: #374151 !important;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: initial;
  line-height: 20px;
}
.checkinBtn:hover {
  background-color: rgba(149, 150, 150, 0.2);
}
</style>
